import { RouterView } from "vue-router";
import { IBreadcrumbMeta } from "cdp-fe-commons-layout";

const Viewer = () => import("@/views/Viewer.vue");

const userRoutes = [
  {
    path: "viewer",
    name: "Anteprima Documento",
    component: RouterView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "",
        name: "viewer",
        component: Viewer,
        meta: {
          requiresAuth: true,
          breadcrumb: {
            exclude: true
          } as IBreadcrumbMeta
        }
      }
    ]
  }
];

export default userRoutes;
